import Notification from 'components/notification';
import { downloadReportAction } from 'contexts/reporting/actions';

export const onDownloadReport = async (id: string): Promise<void> => {
  try {
    const reportUrlResponse = await downloadReportAction(id);
    window.open(reportUrlResponse.result.download_url);
  } catch (error) {
    Notification({
      text: 'There has been a problem generating the link to your report.',
      type: 'error',
    });
  }
};

export const formatDateToLocaleSting = (date: Date): string => {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
export const parseSize = (size: number): string => {
  if (!size) return '-';

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;

  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }

  if (i === 0) {
    size /= 1024;
    i++;
  }

  return `${size.toFixed(2)} ${units[i]}`;
};
export const formatCreatedBy = (
  created_by: { first_name: string; last_name: string },
  scheduled: boolean
): string => {
  return `${scheduled ? 'Scheduled - ' : ''}${created_by.first_name} ${created_by.last_name}`;
};
